{
  "anasayfa": {
    "Aylık Devam Grafiği": "Aylık Devam Grafiği",
    "Bekleyen Anket": "Bekleyen Anket",
    "Doğum Günleri": "Doğum Günleri",
    "Mesai İzin": "Mesai İzin",
    "Müsait olduğunuzda lütfen bekleyen anketlerinizi tamamlayınız": "Müsait olduğunuzda lütfen bekleyen anketlerinizi tamamlayınız.",
    "Resmi Günler": "Resmi Günler",
    "Resmi Tatil": "Resmi Tatil",
    "Takvim Yükleniyor": "Takvim Yükleniyor",
    "Özel Günler": "Özel Günler",
    "İzinler": "İzinler",
    "Proje Sayısı ve Durumları": "Proje Sayısı ve Durumları",
    "Proje Sayısı": "Proje Sayısı",
    "Çalışma Oranı": "Çalışma Oranı",
    "Proje & Genel": "Proje & Genel",
    "Proje ve Genel Saat": "Proje ve Genel Saat",
    "Performans Hariç": "Performans Hariç",
    "Proje Oranı": "Proje Oranı",
    "Doğum Günü Yaklaşanlar": "Doğum Günü Yaklaşanlar",
    "Yaş": "Yaş",
    "Veri çekilirken bir hata oluştu": "Veri çekilirken bir hata oluştu",
    "Bilgiler": "Bilgiler",
    "Takvim": "Takvim",
    "Bağlantı Arşivi": "Bağlantı Arşivi",
    "Hızlı erişim için önemli bağlantılar": "Hızlı erişim için önemli bağlantılar",
    "Dosya Arşivi": "Dosya Arşivi",
    "Sistem dökümanları ve indirilebilir dosyalar": "Sistem dökümanları ve indirilebilir dosyalar",
    "AÇ": "AÇ",
    "Randevu Katılım Onay": "Randevu Katılım Onay",
    "Konum Bilgi Hatası": "Konum Bilgi Hatası",
    "Saat": "Saat",
    "Müşteri": "Müşteri",
    "İşlem": "İşlem",
    "Katılmadım": "Katılmadım",
    "Katıldım": "Katıldım",
    "Yaklaşan Doğum Günleri": "Yaklaşan Doğum Günleri",
    "Bu ay kutlanacak özel günler": "Bu ay kutlanacak özel günler",
    "Yaş Yılı": "Yaş Yılı",
    "Bugün": "Bugün",
    "Gün Kaldı": "Gün Kaldı",
    "Ay": "Ay",
    "Müşteri Yetki Talep": "Müşteri Yetki Talep",
    "On The Jobtraining": "On The Jobtraining",
    "One To One": "One To One"
  }
}
